module.exports = __webpack_public_path__ + "static/img/底部素材@2x.c239bb90.png";